import React, { PureComponent } from 'react';
import get from 'lodash/get';
import { message } from 'antd';

import Modal from '../../../../../components/Modal';
import P from '../../../../../components/P';
import { sendCustomerConfirmationEmail } from '../api';

class ConfirmationMailModal extends PureComponent {
  state = {
    confirmLoading: false,
  };

  handleOk = async () => {
    try {
      this.setState({ confirmLoading: true });
      const { booking } = this.props;
      const response = await sendCustomerConfirmationEmail({
        bookingId: booking.bookingId,
        customerId: booking.customerId,
        bookingUuid: booking.bookingUuid,
      });

      if (response.data[0]?.sent) {
        message.success('Confirmation email has been sent to customer');
      } else {
        message.error('Failed sending confirmation email to customer');
      }

      this.props.closePopup();
      this.setState({ confirmLoading: false });
    } catch (error) {
      message.error(get(error, 'response.data.message', error.message) || 'Failed sending confirmation email to customer');
      this.setState({ confirmLoading: false });
    }
  };

  render() {
    const { closePopup, openedPopup } = this.props;

    return (
      <Modal
        title="Notify the customer"
        visible={openedPopup === 'ConfirmationMailModal'}
        onOk={this.handleOk}
        onCancel={closePopup}
        cancelText="No"
        okText="Send"
        confirmLoading={this.state.confirmLoading}
      >
        <P>Do you want to send a confirmation email of this booking?</P>
      </Modal>
    );
  }
}

export default ConfirmationMailModal;
